import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const TermsModal = ({ show, handleClose }) => {
  return (
    <Modal show={show} onHide={handleClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Terms & Conditions</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h5></h5>
        <ul>
          <li>1. Above quotes are quoted considering minimum 2 adults traveling together</li>
          <li>2. Extra Adult / Child rates mentioned are with extra bed sharing the same room</li>
          <li>3. Jeep Safari will be either in Corbett National Park (Bijrani / Jhirna / Dhela / Durgadevi / Garjia / Dhikala Zones) OR in Corbett Landscape forest area, subject to availability at the time of confirmation</li>
        </ul>

        <h5>Cancellation Policy:</h5>
        <ul>
          <li>1. 48 hours before arrival: No Refund</li>
          <li>2. 3 days before arrival: 50% Refund</li>
          <li>3. 1 Week before arrival: Full refund</li>
        </ul>

        <h5>Safari Rules:</h5>
        <ul>
          <li>1. Safari timings are subject to change as per forest department</li>
          <li>2. Safari bookings are subject to availability</li>
          <li>3. Guests must carry valid ID proof for safari entry</li>
          <li>4. Following forest department guidelines is mandatory</li>
        </ul>

        <h5>General Terms:</h5>
        <ul>
          <li>1. Check-in time: 12:00 PM</li>
          <li>2. Check-out time: 11:00 AM</li>
          <li>3. Package rates are subject to change during peak season</li>
          <li>4. Activities are subject to weather conditions</li>
        </ul>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default TermsModal;